import { ReactNode } from 'react'

import { useAppQR } from '@/api/models/common/hooks/useAppQR'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import StoreAppleSvg from '@/assets/svg/store-apple.svg'
import StoreGoogleSvg from '@/assets/svg/store-google.svg'
import StoreHuaweiSvg from '@/assets/svg/store-huawei.svg'
import RuStoreSvg from '@/assets/svg/store-rustore.svg'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'

import {
  QrStoreType,
  StoreName
} from '../../../widgets/sidebar/ui/Sidebar.types'

const appLinks: {
  title: string
  icon: ReactNode
  type: QrStoreType
}[] = [
  {
    title: StoreName.googlePlay,
    icon: <StoreGoogleSvg />,
    type: QrStoreType.googlePlay
  },
  {
    title: StoreName.appStore,
    icon: <StoreAppleSvg />,
    type: QrStoreType.appStore
  },
  {
    title: StoreName.ruStore,
    icon: <RuStoreSvg />,
    type: QrStoreType.ruStore
  },
  {
    title: StoreName.appGallery,
    icon: <StoreHuaweiSvg />,
    type: QrStoreType.appGallery
  }
]

type Props = {
  setQrStore: (appLinkType: QrStoreType) => void
  setQrOpened: (isOpen: boolean) => void
}

export const AppsBlock = ({ setQrStore, setQrOpened }: Props) => {
  const { reachGoal } = useYandexMetrika()

  const { data: appQR } = useAppQR()

  const getMetricsGoal = (appLinkType: QrStoreType) => {
    switch (appLinkType) {
      case QrStoreType.googlePlay: {
        return YandexMetrikaEvent.MENU_GOOGLEPLAY
      }
      case QrStoreType.appStore: {
        return YandexMetrikaEvent.MENU_APPSTORE
      }
      case QrStoreType.ruStore: {
        return YandexMetrikaEvent.MENU_RUSTORE
      }
      default: {
        return undefined
      }
    }
  }

  const onAppLinkButtonClick = (appLinkType: QrStoreType) => {
    const metricsGoal = getMetricsGoal(appLinkType)
    metricsGoal && reachGoal(metricsGoal)
    setQrStore(appLinkType)
    setQrOpened(true)
  }

  return (
    <div className="flex flex-col">
      <div className="font-bold text-white">
        Вы можете скачать приложение Sminex
      </div>

      <div className="mt-20 flex space-x-20">
        {appLinks.map(appLink => {
          if (
            appQR &&
            Object.entries(appQR).some(
              appType => appType[1] && appType[0] === appLink.type
            )
          ) {
            return (
              <button
                aria-label={`Переход в ${appLink.title} на страницу приложения`}
                key={appLink.type}
                title={appLink.title}
                className="flex h-40 w-40 items-center justify-center overflow-hidden rounded-10 bg-white transition-colors hover:bg-grey-40"
                onClick={() => onAppLinkButtonClick(appLink.type)}
              >
                {appLink.icon}
              </button>
            )
          }
        })}
      </div>
    </div>
  )
}
